import Headroom from 'headroom.js/dist/headroom';
import dropdownEvent from '../base/_dropdownEvent';
// import debug from 'bows/dist/bows';

// const log = debug('navigation');

export default class {
	constructor( node = '.header', opts = {} ) {
		this.node = typeof node === 'string' ? document.querySelector(node) : node;

		if ( ! this.node ) {
			return;
		}

		this.opts = Object.assign( {
			hash: '#menu', // any item that links to this hash will trigger the mobile menu to open
			openClass: 'header--open', // added when the mobile menu is open
			bodyClass: 'fixed', // added to the body when the mobile menu is open
			openEvent: 'kendal:menu:open', // the event that fires when the mobile menu is opened
			closeEvent: 'kendal:menu:close', // the event that fires when the mobile menu is closed

			openItemClass: 'nav__menu-item--active', // added to the nav menu item when activated
			togglerClass: 'nav__menu-item-toggle', // class added to the mobile toggle button
			mobileMediaQuery: '(max-width: 960px)', // media query to disble mouse activation
			outsideNode: '.header__primary-wrap', // any dropdown nodes will not exceed the with of this node
			search: '.header__search', // node for the search wrapper
			searchform: '.searchform--utility', // node for the searchform itself
			menus: '.header__menus', // node for the menus wrapper
			utilityNav: '.header__utility-nav', // for the utility nav wrapper
			logo: '.header__logo--desktop img',
			logoDesktop: '.header__logo--desktop',
			logoMobile: '.header__logo--mobile',
			mobileHeader: '.header__mobile',

			notices: '.kl-notices', // node for the global notices for measurement

			// options passed to headroom.js
			headroom: {
				tolerance: {
					up: 7,
					down: 5
				},
				classes: {
					initial  : 'header',
					pinned   : "header--pinned",
					unpinned : "header--unpinned",
					top      : "header--top",
					notTop   : "header--not-top",
					bottom   : "header--bottom",
					notBottom: "header--not-bottom",
					frozen   : "header--frozen"
				},
				onTop: () => {
					if ( this.node.classList.contains('header--fullbleed') ) {
						const inverse = this.logo.getAttribute('data-inverse');
						if ( inverse && inverse.match(/^https?:\/\/(?:.*)(?:\.(?:png|jpg|gif))$/) ) {
							this.logo.src = inverse;
						}

						if ( this.searchform ) {
							this.searchform.classList.add('searchform--transparent');
						}
					}
				},
				onNotTop: () => {
					if ( this.node.classList.contains('header--fullbleed') ) {
						const src = this.logo.getAttribute('data-src');
						if ( src && src.match(/^https?:\/\/(?:.*)(?:\.(?:png|jpg|gif))$/) ) {
							this.logo.src = src;
						}

						if ( this.searchform ) {
							this.searchform.classList.remove('searchform--transparent');
						}
					}
				},
			},
		}, opts );

		this.opened       = false;
		this.outsideNode  = (typeof this.opts.outsideNode === 'string') ? this.node.querySelector(this.opts.outsideNode) : this.opts.outsideNode;
		this.search       = (typeof this.opts.search === 'string') ? this.node.querySelector(this.opts.search) : this.opts.search;
		this.searchform   = (typeof this.opts.searchform === 'string') ? this.node.querySelector(this.opts.searchform) : this.opts.searchform;
		this.menus        = (typeof this.opts.menus === 'string') ? this.node.querySelector(this.opts.menus) : this.opts.menus;
		this.utilityNav   = (typeof this.opts.utilityNav === 'string') ? this.node.querySelector(this.opts.utilityNav) : this.opts.utilityNav;
		this.notices      = (typeof this.opts.notices === 'string') ? document.querySelector(this.opts.notices) : this.opts.notices;
		this.logo         = (typeof this.opts.logo === 'string') ? this.node.querySelector(this.opts.logo) : this.opts.logo;
		this.logoDesktop  = (typeof this.opts.logoDesktop === 'string') ? this.node.querySelector(this.opts.logoDesktop) : this.opts.logoDesktop;
		this.logoMobile   = (typeof this.opts.logoMobile === 'string') ? this.node.querySelector(this.opts.logoMobile) : this.opts.logoMobile;
		this.mobileHeader = (typeof this.opts.mobileHeader === 'string') ? this.node.querySelector(this.opts.mobileHeader) : this.opts.mobileHeader;

		if ( this.logo ) {
			this.logo.dataset.src = this.logo.src;
		}

		this.adminBar = document.getElementById('wpadminbar');

		if ( this.searchform ) {
			this.searchform.addEventListener('site:focus-within:focus', () => this.node.classList.add('header--search-focused'));
			this.searchform.addEventListener('site:focus-within:blur', () => this.node.classList.remove('header--search-focused'));
		}

		// initialize headroom
		if ( Headroom.cutsTheMustard ) {
			this.headroom = new Headroom( this.node, this.opts.headroom );
			this.headroom.init();
			this.headroom.update(this.headroom); // adds all classes by default just not after initial scroll
		}

		// listen for toggling to the mobile menu and for toggling child menus
		this.node.addEventListener('click', (e) => {
			let node = e.target;

			// get parents up to the primary node
			while (node && node !== this.node) {
				// click on the menu toggle
				if ( node.matches( `[href="${this.opts.hash}"]` ) ) {
					e.preventDefault();
					this.toggle();
					return;
				}

				// click on the toggle submenu
				if ( node.matches(`.${this.opts.togglerClass}`) ) {
					e.preventDefault();

					if (node.parentNode.classList.contains(this.opts.openItemClass)) {
						node.parentNode.classList.remove(this.opts.openItemClass);
						node.innerText = '+';
					} else {
						node.parentNode.classList.add(this.opts.openItemClass);
						node.innerText = '-';
					}

					return;
				}

				// keep going
				node = node.parentNode;
			}
		});

		let getSubMenu = function(menuItem) {
			return Array.from(menuItem.children).filter(n => n.matches('.nav__menu')).shift();
		}

		let intentActivate = (e) => {
			if ( window.matchMedia(this.opts.mobileMediaQuery).matches ) {
				return;
			}

			if ( e.target.classList.contains( this.opts.openItemClass ) ) {
				return;
			}

			e.target.classList.add(this.opts.openItemClass);

			let subMenu = getSubMenu(e.target);

			// prevent the menu from being offscreen
			if ( subMenu && this.outsideNode ) {
				let rect = subMenu.getBoundingClientRect();
				let outsideRect = this.outsideNode.getBoundingClientRect();

				// off right
				if ( rect.right > outsideRect.right ) {
					subMenu.style.marginLeft = `${(rect.right - outsideRect.right) * -1}px`;
				}

				// off left
				if ( rect.left < outsideRect.left ) {
					subMenu.style.marginLeft = `${outsideRect.left - rect.left}px`;
				}
			}

			this.dispatchEvent('kendal:menuitem:enter', e.target);
		}

		let intentDeactivate = (e) => {
			if ( ! e.target.classList.contains( this.opts.openItemClass ) ) {
				return;
			}

			if ( window.matchMedia(this.opts.mobileMediaQuery).matches ) {
				return;
			}

			e.target.classList.remove(this.opts.openItemClass);

			let subMenu = getSubMenu(e.target);

			if ( subMenu ) {
				subMenu.style.marginLeft = '';
			}

			this.dispatchEvent('kendal:menuitem:leave', e.target);
		}

		// add mobile menu togglers & hover intent listeners
		Array.from(this.node.querySelectorAll('.nav__menu-item--has-children')).forEach((node) => {
			const navLink = node.querySelector('.nav__link');

			if ( navLink ) {
				navLink.insertAdjacentHTML('afterend', `<button type="button" class="${this.opts.togglerClass}">+</button>`);
			}

			dropdownEvent(node);
			node.addEventListener('dropdown:activate', intentActivate);
			node.addEventListener('dropdown:deactivate', intentDeactivate);
		});

		// init search form position - move the search form on mobile/desktop resize
		this.repositionSearch(true);

		// resize on notices dismissal
		if (this.notices instanceof HTMLElement) {
			this.notices.addEventListener('notice:remove', this.resize.bind(this));
		}

		document.body.addEventListener('kendal:resize', this.resize.bind(this));
		this.resize();
	}

	getMode() {
		return window.matchMedia(this.opts.mobileMediaQuery).matches ? 'mobile' : 'desktop';
	}

	repositionSearch( force = false ) {
		let currentMode = this.getMode();

		if (!this.search || (!force && this.mode === currentMode)) {
			// nothing to do here
			return;
		}

		this.mode = currentMode;

		if ( 'desktop' === this.mode && this.utilityNav ) {
			// move to desktop
			this.utilityNav.appendChild(this.search);
			return;
		}

		if ( 'mobile' === this.mode && this.menus ) {
			// move to mobile position
			this.menus.appendChild(this.search);
			return;
		}

		// should never ever get here
		throw `how did you get here? - invalid navigation mode: ${this.mode}`;
	}



	open() {
		this.opened = true;
		this.node.classList.add(this.opts.openClass);
		document.body.classList.add(this.opts.bodyClass);

		this.dispatchEvent(this.opts.openEvent);
	}

	close() {
		this.opened = false;
		this.node.classList.remove(this.opts.openClass);
		document.body.classList.remove(this.opts.bodyClass);

		this.dispatchEvent(this.opts.closeEvent);
	}

	toggle() {
		return this.opened ? this.close() : this.open();
	}

	dispatchEvent( eventName, node = this.node, bubbles = true, cancelable = false ) {
		node.dispatchEvent(new CustomEvent(eventName, {
			bubbles: bubbles,
			cancelable: cancelable
		}));
	}

	toggleLogoVisibility() {
		switch( this.getMode() ) {
			case 'desktop':
				if ( this.logoDesktop && ! this.logoDesktop.parentNode ) {
					this.menus.parentNode.insertBefore( this.logoDesktop, this.menus );
				}

				if ( this.logoMobile && this.logoMobile.parentNode ) {
					this.logoMobile.parentNode.removeChild(this.logoMobile);
				}
			break;
			case 'mobile':
				if ( this.logoDesktop && this.logoDesktop.parentNode ) {
					this.logoDesktop.parentNode.removeChild(this.logoDesktop);
				}

				if ( this.logoMobile && ! this.logoMobile.parentNode ) {
					this.mobileHeader.insertBefore( this.logoMobile, this.mobileHeader.firstChild );
				}
			break;
		}
	}

	resize() {
		// maybe reposition the search box from desktop/mobile
		this.repositionSearch();

		// remove the header/desktop home links since they can't be the same and throw an a11y alert for reduntant links
		this.toggleLogoVisibility();

		// close the mobile menu if moved to desktop
		if ( this.opened && 'desktop' === this.getMode() ) {
			this.close();
		}

		// adjust the padding on the body/header from notices
		requestAnimationFrame(() => {
			let adminBarHeight = this.adminBar && 'fixed' === window.getComputedStyle(this.adminBar).position ? this.adminBar.offsetHeight : 0;
			let noticeHeight = this.notices ? this.notices.offsetHeight : 0;
			let headerHeight = this.node.offsetHeight;

			document.body.style.paddingTop = `${adminBarHeight + noticeHeight + headerHeight}px`;
			this.node.style.top = noticeHeight ? `${adminBarHeight + noticeHeight}px` : '';
		});
	}
}
